// extracted by mini-css-extract-plugin
export default {"actionsButton":"ActionsMenu_actionsButton__F08e9"};